import type { StackProps } from '@chakra-ui/react'
import { VStack } from '@chakra-ui/react'
import type { FC } from 'react'
import { StoreType } from 'ecosystem'
import BrandTitle from '../../BrandTitle'
import ProductTitle from '../../ProductTitle'
import { useProductContext } from '../../../hooks/useProductContext'
import MarketplaceProducts from '../../MarketplaceProducts'
import RegularProductPurchaseData from './RegularProductPurchaseData'

type RegularProductInformationProps = StackProps

const RegularProductInformation: FC<RegularProductInformationProps> = ({ ...props }) => {
  const { product, storeType } = useProductContext()

  return (
    <VStack spacing={3} {...props}>
      <VStack spacing={0} w="100%">
        {product.brand?.name ? <BrandTitle title={product.brand.name} /> : null}
        <ProductTitle flex={1} title={product.name} />
      </VStack>
      {storeType === StoreType.MARKETPLACE ? (
        <MarketplaceProducts />
      ) : (
        <RegularProductPurchaseData />
      )}
    </VStack>
  )
}

export default RegularProductInformation
